import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule  } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';
//import { NgxEditorModule } from 'ngx-editor';


import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import {ChatUserListComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import {FriendComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import {ChatMsgComponent} from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import {NgxSimpleTextEditorModule} from 'ngx-simple-text-editor';
import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';
import {ArchwizardModule} from 'angular-archwizard';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbAccordionModule, NgbButtonsModule, NgbCollapseModule, NgbDropdownModule, NgbPaginationModule, NgbTabsetModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './page/login/login.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { ToastrModule } from 'ngx-toastr';
import {TextMaskModule} from 'angular2-text-mask';
import {NgNumberFormatterModule} from 'ng-number-formatter';

import { FullTextSearchPipe  } from './shared/filter.pipe';
import { SanitizeHtmlPipe  } from './shared/sanitize.pipe';
import { LoggedInGuard } from './page/security/loggedin.quard';
import { NgxSpinnerModule } from 'ngx-spinner';
import {ColorPickerModule} from 'ngx-color-picker';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './page/home/home.component';
import {TinymceModule} from 'angular2-tinymce';
import { SelectModule } from 'ng-select';
import {TagInputModule} from 'ngx-chips';
import {DragulaModule, DragulaService} from 'ng2-dragula';
import { SelectOptionService } from './theme/shared/components/select/select-option.service';
import { BarRatingModule } from 'ngx-bar-rating';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderByPipe } from './shared/orderBy.pipe';
import { HomeGestaoComponent } from './page/home-gestao/home-gestao.component';
import { HomeOperadoraComponent } from './page/home-operadora/home-operadora.component';
import { HomeEmpresaComponent } from './pages/Empresa/home-empresa/home-empresa.component';
import { CadastroPesquisadorComponent } from './pages/Empresa/cadastro-pesquisador/cadastro-pesquisador.component';
import { CadastroTradutorComponent } from './pages/Empresa/cadastro-tradutor/cadastro-tradutor.component';
import { CadastroAdvogadoComponent } from './pages/Empresa/cadastro-advogado/cadastro-advogado.component';
import { ChatComponent } from './pages/Empresa/chat/chat.component';
import { LandpageComponent } from './pages/site/landpage/landpage.component';
import { ColetaTradutorComponent } from './pages/site/coleta-tradutor/coleta-tradutor.component';
import { ColetaPesquisadorComponent } from './pages/site/coleta-pesquisador/coleta-pesquisador.component';
import { ColetaAdvogadoComponent } from './pages/site/coleta-advogado/coleta-advogado.component';
import { ColetaClienteComponent } from './pages/site/coleta-cliente/coleta-cliente.component';
import { CadastroClienteComponent } from './pages/Empresa/cadastro-cliente/cadastro-cliente.component';
import { EmConstrucaoComponent } from './pages/site/em-construcao/em-construcao.component';
import { PerfilClienteComponent } from './pages/Cliente/perfil-cliente/perfil-cliente.component';
import { DocumentosComponent } from './pages/Cliente/documentos/documentos.component';
import { ChatClienteComponent } from './pages/Cliente/chat-cliente/chat-cliente.component';
import { HomeClienteComponent } from './pages/Cliente/home-cliente/home-cliente.component';
import { CadastroCartorioComponent } from './pages/Empresa/cadastro-cartorio/cadastro-cartorio.component';
import { StatusClienteComponent } from './pages/Empresa/status-cliente/status-cliente.component';
import { CadastroMentoradoComponent } from './pages/Empresa/cadastro-mentorado/cadastro-mentorado.component';






//import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app';
//import {getDatabase, provideDatabase } from '@angular/fire/database';
//import { environment } from 'src/environments/environment';



//import { AdvRatingComponent } from './demo/ui-elements/ui-adv/adv-rating/adv-rating.component';


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ChatUserListComponent,
    FriendComponent,
    ChatMsgComponent,
    ConfigurationComponent,
    ToggleFullScreenDirective,
    LoginComponent,
    HomeComponent,
    FullTextSearchPipe,
    SanitizeHtmlPipe,
    OrderByPipe,   
    HomeGestaoComponent,
    HomeOperadoraComponent,
    HomeEmpresaComponent,
    CadastroPesquisadorComponent,
    CadastroTradutorComponent,
    CadastroAdvogadoComponent,
    ChatComponent,
    LandpageComponent,
    ColetaTradutorComponent,
    ColetaPesquisadorComponent,
    ColetaAdvogadoComponent,
    ColetaClienteComponent,
    CadastroClienteComponent,
    EmConstrucaoComponent,
    PerfilClienteComponent,
    DocumentosComponent,
    ChatClienteComponent,
    HomeClienteComponent,
    CadastroCartorioComponent,
    StatusClienteComponent,
    CadastroMentoradoComponent


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule ,
    SharedModule,
    NgbModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    NgbCollapseModule,
    NgbAccordionModule,
    NgbPaginationModule,
    FileUploadModule,
    NgxSpinnerModule,
    TextMaskModule,
    ColorPickerModule,
    HttpClientModule,
    TinymceModule,
    SelectModule,
    TagInputModule,
    DragulaModule,
    BarRatingModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    ArchwizardModule,
    NgxSimpleTextEditorModule,
    ToastrModule.forRoot()
    //NgxEditorModule,
    //provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    //provideDatabase(() => getDatabase()),
    


  ],
  providers: [NavigationItem, LoggedInGuard, DragulaService, SelectOptionService],
  bootstrap: [AppComponent]
})
export class AppModule { }
